import styled from '@emotion/styled';

import {Props} from '.';

const HEIGHT = 48;

export const Step = styled.div`
  border: 2px solid var(--color-core-grey-light);
  border-radius: 50%;
  background-color: var(--color-core-grey-light);
  width: 24px;
  height: 24px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 24px;
`;

export const StepLabel = styled.div`
  margin-top: var(--gutter-big);
  margin-left: -300%;
  margin-right: -300%;
  text-align: center;
  font-size: var(--font-size-tiny);
  font-weight: var(--font-weight-highlight);
  color: var(--color-core-grey);
`;

export const Connector = styled.div`
  background-color: var(--color-core-grey-light);
  margin-top: 10px;
  height: 4px;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 40px;
`;

export const StyledStepper = styled.div<Props>`
  display: flex;
  height: ${HEIGHT}px;

  ${Step}:nth-of-type(-n + ${({currentIndex}): number =>
    currentIndex * 2 + 1}) {
    border-color: var(--color-core-primary);
    background-color: var(--color-core-primary);
  }

  ${Connector}:nth-of-type(-n + ${({currentIndex}): number =>
    currentIndex * 2 + 1}) {
    background-color: var(--color-core-primary);
  }
`;
